import DeploymentDetailsContainer from './DeploymentDetails.container';

export default DeploymentDetailsContainer;
